export default "__VITE_ASSET__CCLLwz2F__"